import { render } from "./AccountSaved.vue?vue&type=template&id=0c23c186"
import script from "./AccountSaved.vue?vue&type=script&lang=js"
export * from "./AccountSaved.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__